export default "__VITE_ASSET__284ec974__"